/**
 * 把文件拉成 blob 再触发浏览器下载。
 * 直接给 <a download> 在跨域（接口域名和页面域名不同）时会被浏览器忽略，视频/图片会在新窗口里打开而不是下载，
 * 所以先取回内容再保存。适合几十 MB 以内的文件（视频上限 100MB）。
 */
export async function downloadFileAsBlob(url: string, fileName: string): Promise<void> {
  const resp = await fetch(url, { credentials: 'include' as RequestCredentials });
  if (!resp.ok) throw new Error('下载失败');
  const blob = await resp.blob();
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  anchor.download = fileName || 'download';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  setTimeout(() => { try { URL.revokeObjectURL(objectUrl); } catch { /* ignore */ } }, 1500);
}
